const rxpadPrescriberAgreementContent = /* HTML */ `<!DOCTYPE html>
  <html lang="en-AU">
    <head>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta charset="utf-8" />
      <style>
        * {
          font-family: Calibri;
        }
        section:not(:last-of-type) {
          border-bottom: 1pt solid #000;
          padding-bottom: 4pt;
        }
        p,
        ul,
        li {
          font-size: 9pt;
        }
        li {
          margin: 2pt 0;
          line-height: 14pt;
          list-style-type: none;
          position: relative;
        }
        ul li::before {
          content: '•';
          position: absolute;
          left: -10pt;
          font-size: 12pt;
          line-height: 16pt;
        }
        section > ol > li {
          span {
            line-height: 16pt;
            margin-right: 10pt;
          }

          &:first-of-type {
            font-weight: bold;
            color: #ed7d31;
          }
        }
        h3 {
          font-size: 12pt;
          color: #ed7d31;
          text-align: center;
        }
      </style>
    </head>
    <body>
      <section>
        <h3>RxPad Terms and Conditions</h3>
        <p>
          Welcome to RxPad! We provide access to the efficient and secure e-scripting solution
          either via Telecare Australia Pty Ltd or integrating a third-party practice’s access to
          your Account (<strong>Services</strong>), as set out in more detail on our website
          (<strong>Site</strong>).
        </p>

        <p>
          In these Terms, when we say <strong>you</strong> or <strong>your</strong>, we mean you as
          an individual if you are accepting these Terms for yourself. If you are accepting these
          Terms on behalf of an entity (such as your employer) and you are authorised to do so, then
          <strong>you</strong> or <strong>your</strong> means that entity. When we say
          <strong>we</strong>, <strong>us</strong>, or <strong>our</strong>, we mean Telecare
          Australia Pty Ltd (ACN 632 722 911).
        </p>

        <p>
          These terms and conditions (<strong>Terms</strong>) form our contract with you, and set
          out our obligations as a service provider and your obligations as a customer. You cannot
          use the Services unless you agree to these Terms.
        </p>

        <p>
          Some capitalised words in these Terms have defined meanings, and each time that word is
          used in these Terms it has the same meaning. You can find a list of the defined words and
          their meaning at the end of these Terms.
        </p>

        <p>
          <strong>DISCLAIMER:</strong> RxPad is a software as a service platform only
          (<strong>Platform</strong>). By using the Platform, you acknowledge and agree that nothing
          provided on the Platform by us may be taken to be advice about appropriate treatments,
          medications or prescriptions. We do not, in any way, seek to provide you confirmation that
          the medication you have prescribed is appropriate or otherwise, inappropriate. We provide
          the Platform as a software as a service platform provider for the sole purposes of
          allowing you to issue electronic prescriptions to your patients.
        </p>
      </section>
      <section>
        <h3>OUR DISCLOSURES</h3>
        <p>Please read these Terms carefully before you accept. We draw your attention to:</p>
        <ul>
          <li>
            our privacy policy (on the Site) which sets out how we will handle your personal
            information;
          </li>
          <li>clause 1.7 (Variations) which sets out how we may amend these Terms;</li>
          <li>
            clause 3 (Fees) which sets out important information about payments and recurring
            services, including whether you can cancel the Services and whether any of the Services
            auto-renew; and
          </li>
          <li>
            clause 10 (Liability) which sets out exclusions and limitations to our liability under
            these Terms.
          </li>
        </ul>
        <p>
          We may receive a benefit (which may include a referral fee or a commission) should you
          visit certain third-party websites through a link in the Services, or for featuring
          certain goods or services on the Services.
        </p>
        <p>
          <strong>
            These Terms do not intend to limit your rights and remedies at law, including any of
            your Consumer Law Rights.
          </strong>
        </p>
      </section>
      <section>
        <ol>
          <li><span>1.</span>Engagement and term</li>
          <li>
            <span>1.1</span>These Terms apply from the time you agree to these Terms, until the
            date these Terms are terminated in accordance with their Terms (<strong>Term</strong>).
          </li>
          <li>
            <span>1.2</span>Subject to your compliance with these Terms, we will provide you with
            access to the Services.
          </li>
          <li>
            <span>1.3</span>Where we require access to your premises or computer systems in order
            to provide the Services, you agree to provide us with such access free from risk to the
            safety of our employees and contractors.
          </li>
          <li>
            <span>1.4</span>We will not be responsible for any other services unless expressly set
            out in these Terms or on our Site.
          </li>
          <li>
            <span>1.5</span>If we provide you with access to any new or beta services, you
            acknowledge that because of the developmental nature of such services, you use them at
            your own risk and we have no obligation to maintain or provide error corrections. Any
            new or beta services we provide you with access to are for evaluation purposes only and
            not for production use, and we may discontinue those services at any time at our sole
            discretion.
          </li>
          <li>
            <span>1.6</span>Where you engage third parties to operate alongside the Services (for
            example, any third-party software systems you wish to integrate with the Services),
            those third parties are independent of us and you are responsible for (meaning we will
            not be liable for) the goods or services they provide, unless we expressly agree
            otherwise.
          </li>
          <li>
            <span>1.7</span>We may amend these Terms at any time, by providing written notice to
            you. By clicking “I accept” or continuing to use the Services after the notice or 30
            days after notification (whichever date is earlier), you agree to the amended Terms. If
            you do not agree to the amendment, you should cease using the Services. If you have paid
            upfront for recurring access to any of the Services (excluding one-time purchases) and
            you would like to cancel them, please contact us in writing within 30 days of receiving
            notice to cancel that recurring access and we will issue you a pro-rata refund for such
            Services.
          </li>
        </ol>
        <ol>
          <li><span>2.</span>Account</li>
          <li>
            <span>2.1</span>You must sign up for an Account in order to access and use the
            Services.
          </li>
          <li>
            <span>2.2</span>You may invite Authorised Users to access and use the Services under
            your Account. You are responsible for ensuring that your Authorised Users comply with
            these Terms. You may change who your Authorised Users are at any time through your
            Account, and what access rights or permissions they have when using the Services. Any
            limitations on the number of Authorised Users you can have will be set out in your
            Account or on the Services.
          </li>
          <li>
            <span>2.3</span>While you have an Account with us, you agree to (and to ensure your
            Authorised Users agree to):
            <ol>
              <li>
                <span>(a)</span>keep your information up-to-date (and ensure it remains true,
                accurate and complete);
              </li>
              <li>
                <span>(b)</span>keep usernames and passwords secure and confidential, and protect
                them from misuse or being stolen; and
              </li>
              <li>
                <span>(c)</span>notify us if you become aware of, or have reason to suspect, any
                unauthorised access to your Account or any logins linked to your Account.
              </li>
              <li></li>
            </ol>
          </li>
          <li>
            <span>2.4</span>If you close your Account, you and your Authorised Users will lose
            access to the Services.
          </li>
        </ol>
        <ol>
          <li><span>3.</span>Fees</li>
          <li>
            <span>3.1</span>While you have an Account with us and are a contractor of ours, we will
            provide you with access to the Services for free.
          </li>
          <li>
            <span>3.2</span>If during your Account term you cease being a contractor of ours,
            subject to clause 3.4, you may continue to access your Account if you purchase the
            Services from us, as set out on our Site or otherwise set out in writing between the
            (<strong>Paid Services</strong>). Paid Services include recurring access to the Services
            under your existing Account and linked to your new practice. You must pay all amounts
            due under these Terms in accordance with these Terms or as set out on our Site (as
            applicable).
          </li>
          <li>
            <span>3.3</span>Details of our Paid Services, including features, limitations, fees and
            billing cycles (for recurring services) are set out on our Site. For recurring services,
            you will be billed on a regular basis, as set out on our Site, at the beginning of each
            billing cycle. All other Paid Services must be paid for at the time you order the
            Service.
          </li>
          <li>
            <span>3.4</span>Where you are no longer a contractor of ours, your free access to the
            Services and access to our patient information will cease immediately and you will no
            longer have access to the Services via your Account that is linked to our practice.
          </li>
          <li>
            <span>3.5</span><strong>Cancellation of Paid Services:</strong> All recurring Paid
            Services continue for the agreed Service term (that you selected when purchasing the
            Service) (<strong>Service Term</strong>).
          </li>
          <li>
            <span>3.6</span><strong>Cancellation of Services:</strong> If you wish to cancel your
            free access to Services, please get in contact with us via your Account.
          </li>
          <li>
            <span>3.7</span>At the end of each Service Term, provided you have paid all fees owing
            (where applicable), your recurring Services or Paid Services will be automatically
            renewed for the same term. If you wish to cancel your recurring Services, you may do so
            through your Account.
          </li>
          <li>
            <span>3.8</span>Your cancellation will take effect at the end of your current Service
            Term, and the recurring Services or Paid Services will not be renewed (meaning you will
            need to continue paying all fees due up until your current Service Term ends).
          </li>
          <li>
            <span>3.9</span>Our payments methods will be set out at the time you purchase the Paid
            Services. If you choose to pay your fees using one of our third-party payment
            processors, you may need to accept their terms and conditions (if this is the case,
            these will be set out at the time you make payment).
          </li>
          <li>
            <span>3.10</span>You must not pay, or attempt to pay, any fees due under these Terms or
            as a result of your use of the Services or Paid Services by fraudulent or unlawful
            means. If you make payment by debit or credit card, you must be the authorised card
            holder. If payment is made by direct debit, by providing your bank account details and
            accepting these Terms, you authorise our nominated third-party payment processor to
            debit your bank account, and you confirm that you are either the holder or an authorised
            signatory of that bank account.
          </li>
          <li>
            <span>3.11</span>If any fees due under these Terms or as a result of your use of the
            Paid Services are not paid on time, we may:
            <ol>
              <li><span>(a)</span>suspend your access to the Services;</li>
              <li>
                <span>(b)</span>charge interest on any overdue payments at a rate equal to the
                Reserve Bank of Australia’s cash rate, from time-to-time, plus 2% per annum,
                calculated daily and compounding monthly.
              </li>
            </ol>
          </li>
          <li>
            <span>3.12</span>You are responsible for paying any levies or taxes associated with
            your use of the Services, for example sales taxes, value-added taxes or withholding
            taxes (unless we are required by law to collect these on your behalf).
          </li>
        </ol>
        <ol>
          <li><span>4.</span>Licence</li>
          <li>
            <span>4.1</span>During the Term, we grant you and your Authorised Users a right to use
            our basic Services in accordance with these Terms. This right cannot be passed on or
            transferred to any other person.
          </li>
          <li>
            <span>4.2</span>When you purchase our Paid Services, your access rights will vary based
            on the type of service. For recurring services, we grant you and your Authorised Users a
            right to access the relevant Services only for the duration that you continue to pay for
            the Service, subject to these Terms. These rights cannot be passed on or transferred to
            any other person.
          </li>
          <li>
            <span>4.3</span>You must not (and you must ensure that your Authorised Users do not):
            <ol>
              <li>
                <span>(a)</span>access or use the Services in any way that is improper or breaches
                any laws, infringes any person's rights (for example, intellectual property rights
                and privacy rights), or gives rise to any civil or criminal liability;
              </li>
              <li>
                <span>(b)</span>interfere with or interrupt the supply of the Services, or any
                other person’s access to or use of the Services;
              </li>
              <li>
                <span>(c)</span>introduce any viruses or other malicious software code into the
                Services;
              </li>
              <li>
                <span>(d)</span>use any unauthorised or modified version of the Services, including
                but not limited to for the purpose of building similar or competitive software or
                for the purpose of obtaining unauthorised access to the Services;
              </li>
              <li>
                <span>(e)</span>attempt to access any data or log into any server or account that
                you are not expressly authorised to access;
              </li>
              <li>
                <span>(f)</span>use the Services in any way that involves service bureau use,
                outsourcing, renting, reselling, sublicensing, concurrent use of a single user
                login, or time-sharing;
              </li>
              <li>
                <span>(g)</span>circumvent user authentication or security of any of our networks,
                accounts or hosts or those of any third party; or
              </li>
              <li>
                <span>(h)</span>access or use the Services to transmit, publish or communicate
                material that is, defamatory, offensive, abusive, indecent, menacing, harassing or
                unwanted.
              </li>
            </ol>
          </li>
        </ol>
        <ol>
          <li><span>5.</span>Availability, Disruption and Downtime</li>
          <li>
            <span>5.1</span>While we strive to always make the Services available to you, we do not
            make any promises that these will be available 100% of the time. The Services may be
            disrupted during certain periods, including, for example, as a result of scheduled or
            emergency maintenance.
          </li>
          <li>
            <span>5.2</span>The Services may interact with, or be reliant on, products or services
            provided by third parties, such as cloud hosting service providers. To the maximum
            extent permitted by law, we are not liable for disruptions or downtime caused or
            contributed to by these third parties.
          </li>
          <li>
            <span>5.3</span>We will try to provide you with reasonable notice, where possible, of
            any disruptions to your access to the Services.
          </li>
        </ol>
        <ol>
          <li><span>6.</span>Intellectual Property and Data</li>
          <li>
            <span>6.1</span>We own all intellectual property rights in the Services. This includes
            how the Services look and function, as well as our copyrighted works, trademarks,
            inventions, designs and other intellectual property. You agree not to copy or otherwise
            misuse our intellectual property without our written permission (for example, to reverse
            engineer or discover the source code of our intellectual property), and you must not
            alter or remove any confidentiality, copyright or other ownership notice placed on the
            Services.
          </li>
          <li>
            <span>6.2</span>We may use any feedback or suggestions that you give us in any manner
            which we see fit (for example, to develop new features), and no benefit will be owed to
            you as a result of any use by us of your feedback or suggestions.
          </li>
          <p>
            <strong>Your Data</strong> 
          </p>
          <li>
            <span>6.3</span>We do not own any of Your Data, but when you enter or upload any of Your
            Data into the Services, you grant us the right to access, analyse, backup, copy, store,
            transmit, and otherwise use Your Data for the duration of your use of the Services (and
            for a reasonable period of time afterwards). We may use Your Data (or disclose it to
            third party service providers) to:
            <ol>
              <li>
                <span>(a)</span>supply the Services to you and your Authorised Users (for example,
                to enable you and your Authorised Users to access and use the Services), and
                otherwise perform our obligations under these Terms;
              </li>
              <li><span>(b)</span>diagnose problems with the Services;</li>
              <li><span>(c)</span>improve, develop and protect the Services;</li>
              <li>
                <span>(d)</span>send you information we think may be of interest to you based on
                your marketing preferences;
              </li>
              <li>
                <span>(e)</span>perform analytics for the purpose of remedying bugs or issues with
                the Services; or
              </li>
              <li>
                <span>(f)</span>perform our obligations under these Terms (as reasonably required).
              </li>
            </ol>
          </li>
          <li>
            <span>6.4</span>You acknowledge and agree that because of the nature of the internet,
            the processing and transmission of Your Data by us may occur over various networks.
          </li>
          <li>
            <span>6.5</span>You are responsible for (meaning we are not liable for):
            <ol>
              <li>
                <span>(a)</span>the integrity of Your Data on your systems, networks or any device
                controlled by you or your Authorised Users; and
              </li>
              <li><span>(b)</span>backing up Your Data.</li>
            </ol>
          </li>
          <li>
            <span>6.6</span>When you use the Services, we may create anonymised statistical data
            from Your Data and usage of the Services (for example, through aggregation). Once
            anonymised, we own that data and may use it for our own purposes, such as to provide and
            improve the Services, to develop new services or product offerings, to identify business
            trends, and for other uses we communicate to you. This may include making such
            anonymised data publicly available, provided it is not compiled using a sample size
            small enough to make underlying portions of Your Data identifiable.
          </li>
          <li>
            <span>6.7</span>If you do not provide Your Data to us, it may impact your ability to
            receive the Services.
          </li>
          <li>
            <span>6.8</span>This clause 6 will survive the termination or expiry of these Terms.
          </li>
        </ol>
        <ol>
          <li><span>7.</span>Warranties</li>
          <li>
            <span>7.1</span>You represent, warrant, and agree that:
            <ol>
              <li>
                <span>(a)</span>you will not use our Services, including our intellectual property,
                in any way that competes with our business;
              </li>
              <li>
                <span>(b)</span>there are no legal restrictions preventing you from entering into
                these Terms;
              </li>
              <li>
                <span>(c)</span>you will promptly inform us if you change your place of work (e.g.
                move to a different clinic or practice which may result in a cessation of your free
                access to the Services);
              </li>
              <li>
                <span>(d)</span>all information and documentation that you provide to us in
                connection with these Terms is true, correct and complete; and
                <ol>
                <li>
                  <span>(1)</span>you, and where applicable, your Authorised Users will comply with
                  all applicable codes, laws, standards and regulations including but not limited
                  to:
                  <ol>
                    <li><span>A.</span>the Health Practitioner National Law;</li>
                    <li><span>B.</span>the Medical Board of Australia Code of Conduct;</li>
                    <li>
                      <span>C.</span>the Australian Medical Association Guidelines on Medical
                      Certifications 2011 (revised 2016); and
                    </li>
                    <li><span>D.</span>any relevant State and Territory Health Records Acts;</li>
                  </ol>
                </li>
                <li>
                  <span>(2)</span>you (and your Authorised Users) hold all necessary licenses with
                  relevant regulatory boards and/or authorities necessary to enable you and your
                  Authorised Users to legally prescribe medication and issue prescriptions to
                  patients;
                </li>
                <li>
                  <span>(3)</span>you will promptly notify us of any changes to any of your (or
                  your Authorised Users’) Professional Registration Details or other qualifications,
                  certifications, licenses and permits necessary for you or your Authorised Users to
                  use the Services and/or prescribe medications to patients;
                </li>
                <li>
                  <span>(4)</span>you will promptly notify us of any breaches of any laws, rules,
                  regulations, industry codes or serious claims for misconduct or professional
                  negligence by you or your Authorised Users;
                </li>
                <li>
                  <span>(5)</span>you will maintain all insurance policies which a reasonably
                  prudent healthcare professional in your position would maintain, including but not
                  limited to professional indemnity cover and public liability insurances;
                </li>
                <li>
                  <span>(6)</span>when you or your Authorised Users prescribe medications to
                  patients as part of the Services, you (or your Authorised Users) will:
                  <ol>
                    <li>
                      <span>i.</span>ensure all medications are prescribed in accordance with all
                      regulatory and legislative requirements in addition to ethical and
                      professional obligations relevant to the practice of medicine; and
                    </li>
                    <li>
                      <span>ii.</span>ensure that the patient understands that the prescription
                      will be sent to them electronically.
                    </li>
                  </ol>
                </li>
              </ol>
              </li>
              
            </ol>
          </li>
          <li>
            <span>7.2</span>This clause 7 will survive the termination or expiry of these Terms.
          </li>
        </ol>
        <ol>
          <li><span>8.</span>Confidential Information and Personal Information</li>
          <li>
            <span>8.1</span>While using the Services, you may share confidential information with
            us, and you may become aware of confidential information about us. You agree not to use
            our confidential information, and to take reasonable steps to protect our confidential
            information from being disclosed without our permission, and we agree to do the same for
            your confidential information. This also means making sure that any Authorised Users,
            employees, contractors, professional advisors or agents of ours or yours only have
            access to confidential information on a ‘need-to-know basis’ (in other words, the
            disclosure is absolutely necessary), and that they also agree to not misuse or disclose
            such confidential information.
          </li>
          <li>
            <span>8.2</span>However, either you or we may share confidential information with legal
            or regulatory authorities if required by law to do so.
          </li>
          <li>
            <span>8.3</span>We collect, hold and disclose and use any Personal Information you
            provide to us in accordance with our privacy policy, available on the Site, and
            applicable privacy laws.
          </li>
          <li>
            <span>8.4</span>You must only:
            <ol>
              <li>
                <span>(a)</span>disclose Personal Information to us (including via the Services) if
                you have the right to do so (such as having the individual’s express consent); and
              </li>
              <li>
                <span>(b)</span>use the Personal Information in accordance with your patients’
                instructions and for the sole purpose for which it was disclosed.
              </li>
            </ol>
          </li>
          <li>
            <span>8.5</span>We may need to disclose Personal Information to third parties, such as
            our related companies or our service providers (for example, IT and administrative
            service providers and our professional advisors).
          </li>
          <li>
            <span>8.6</span>Where we are required by law to report on our activities, you
            acknowledge that from time to time we may request certain information from you in order
            to meet our requirements, and you agree to provide us with such information within the
            timeframes reasonably requested by us.
          </li>
          <li>
            <span>8.7</span>This clause 8 will survive the termination or expiry of these Terms.
          </li>
          <li>
            <span>8.8</span>You acknowledge and agree that we are registered on the Electronic
            Prescribing Conformance Register as outlined here
            https://www.digitalhealth.gov.au/healthcare-providers/initiatives-and-programs/my-health-record/conformant-clinical-software-products.
          </li>
          <li>
            <span>8.9</span>You agree to comply with the legal requirements of the:
            <ol>
              <li><span>(a)</span><i>Health Care Identifiers Act 2010</i> (Cth);</li>
              <li><span>(b)</span><i>Health Care Identifiers Regulations 2010</i> (Cth);</li>
              <li><span>(c)</span><i>My Health Records Act 2012</i> (Cth); and</li>
              <li><span>(d)</span><i>My Health Records Regulation 2012</i> (Cth).</li>
            </ol>
          </li>
          <li>
            <span>8.10</span>Each Party agrees to comply with the legal requirements of the
            Australian Privacy Principles as set out in the Privacy Act 1988 (Cth) (<strong
              >Privacy Act</strong
            >) (as if it were an “APP entity” as defined in the Privacy Act) and any other
            applicable Privacy Laws that may apply to the use of the Services. Each Party must not
            (and must procure that its personnel do not) do anything which may cause the other Party
            to be in breach of any Privacy Laws.
          </li>
          <li>
            <span>8.11</span>In respect of any Security Incident, you must (and procure your
            Authorised Users must):
            <ol>
              <li>
                <span>(a)</span>notify us within 2 business days of becoming aware of the Security
                Incident;
              </li>
              <li><span>(b)</span>provide us with all information we reasonably request;</li>
              <li>
                <span>(c)</span>assist and fully cooperate with us, at your cost, in investigating
                and remedying the Security Incident; and
              </li>
              <li>
                <span>(d)</span>take any other action, at your cost, that we reasonably deem
                necessary in connection with the Security Incident.
              </li>
            </ol>
          </li>
          <li>
            <span>8.12</span>This clause 8 will survive the termination or expiry of these Terms.
          </li>
        </ol>
        <ol>
          <li><span>9.</span>Consumer Law Rights</li>
          <li>
            <span>9.1</span>In some jurisdictions, you may have guarantees, rights or other
            remedies provided by law (<strong>Consumer Law Rights</strong>), and these Terms do not restrict your
            Consumer Law Rights. We will only be bound by your Consumer Law Rights and the express
            wording of these Terms.
          </li>
          <li>
            <span>9.2</span>Subject to your Consumer Law Rights, we do not provide a refund for a
            change of mind or change in circumstance.
          </li>
          <li>
            <span>9.3</span>If you accept these Terms in Australia, nothing in these Terms should
            be interpreted to exclude, restrict or modify the application of, or any rights or
            remedies you may have under, any part of the Australian Consumer Law (as set out in
            Schedule 2 of the <i>Competition and Consumer Act 2010 </i>(Cth)).
          </li>
          <li>
            <span>9.4</span>This clause 8.8 will survive the termination or expiry of these Terms. 
          </li>
        </ol>
        <ol>
          <li><span>10.</span>Liability</li>
          <li>
            <span>10.1</span>To the maximum extent permitted by law, we will not be liable for, and
            you release us from liability for, any Liability caused or contributed to by, arising
            from or in connection with:
            <ol>
              <li>
                <span>(a)</span>your computing environment (for example, your hardware, software,
                information technology and telecommunications services and systems); or
              </li>
              <li>
                <span>(b)</span>any use of the Services by a person or entity other than you or
                your Authorised Users.
              </li>
            </ol>
          </li>
          <li>
            <span>10.2</span>Regardless of whatever else is stated in these Terms, to the maximum
            extent permitted by law:
            <ol>
              <li><span>(a)</span>neither we or you are liable for any Consequential Loss;</li>
              <li>
                <span>(b)</span>a party’s liability for any Liability under these Terms will be
                reduced proportionately to the extent the relevant Liability was caused or
                contributed to by the actions (or inactions) of the other party, including any
                failure by the other party to mitigate its loss;
              </li>
              <li>
                <span>(c)</span>(where the Services are not ordinarily acquired for personal,
                domestic or household use or consumption) in respect of any failure by us to comply
                with relevant Consumer Law Rights, our Liability is limited (at our discretion) to
                supplying the Services again or paying the cost of having the Services supplied
                again; and
              </li>
              <li>
                <span>(d)</span>our aggregate liability to you for any Liability arising from or in
                connection with these Terms will be limited to the amount of any fees paid by you to
                us during the 12 months immediately preceding the event giving rise to the
                Liability, or if you have not paid for the Service, to AU$1,000.
              </li>
            </ol>
          </li>
          <li>
            <span>10.3</span>This clause 10 will survive the termination or expiry of these Terms.
          </li>
        </ol>
        <ol>
          <li><span>11.</span>Indemnity</li>
          <li>
            <span>11.1</span>Despite anything to the contrary, to the maximum extent permitted by
            Law, you are liable for, and agree to indemnify us and hold us harmless in respect of
            any Liability that we may suffer, incur or otherwise become liable for, arising from or
            in connection with:
            <ol>
              <li>
                <span>(a)</span>your (or your Authorised Users’) provision of any electronic
                prescriptions to patients made as part of the Services, including the medications
                you prescribe to patients;
              </li>
              <li>
                <span>(b)</span>any breach by you or your Authorised Users of clause 7 and 8.
              </li>
            </ol>
          </li>
          <li>
            <span>11.2</span>This clause 11will survive the termination or expiry of these Terms.
          </li>
        </ol>
        <ol>
          <li><span>12.</span>Suspension and Termination</li>
          <p>
            <strong><i>Suspension</i></strong>
          </p>
          <li>
            <span>12.1</span>We may suspend your access to the Services where we reasonably believe
            there has been any unauthorised access to or use of the Services (such as the
            unauthorised sharing of login details for the Services). If we suspend your access to
            the Services, we will let you know within a reasonable time of doing so, and we will
            work with you to resolve the matter, or if it cannot be resolved, then we may terminate
            these Terms and your access to the Services will end.
          </li>
          <p>
            <strong><i>Termination</i></strong>
          </p>
          <li>
            <span>12.2</span>We may terminate these Terms immediately at any time by notifying you
            through your Account or to your email for notices and if you have paid upfront for
            ongoing access to any of the Services (excluding one-time purchases) we will issue you a
            pro-rata refund for such Services.
          </li>
          <li>
            <span>12.3</span>We may terminate these Terms (meaning you will lose access to the
            Services, and any recurring Services will be cancelled) if:
            <ol>
              <li>
                <span>(a)</span>at any time, you are no longer a contractor of ours, by notifying
                you through your Account or to your email;
              </li>
              <li><span>(b)</span>you fail to pay your applicable fees when they are due;</li>
              <li>
                <span>(c)</span>you or your Authorised Users breach these Terms and do not remedy
                that breach within 14 days of us notifying you of that breach;
              </li>
              <li>
                <span>(d)</span>you or your Authorised Users breach these Terms and that breach
                cannot be remedied; or
              </li>
              <li>
                <span>(e)</span>we decide to discontinue the Services, in which case we will
                provide you with at least 90 days’ written notice and if you have paid upfront for
                ongoing access to any of the Services (excluding one-time purchases) we will issue
                you a pro-rata refund for such Services; or
              </li>
              <li>
                <span>(f)</span>you experience an insolvency event (including but not limited to
                bankruptcy, receivership, voluntary administration, liquidation, or entering into
                creditors’ schemes of arrangement).
              </li>
            </ol>
          </li>
          <li>
            <span>12.4</span>You may terminate these Terms if:
            <ol>
              <li>
                <span>(a)</span>we breach these Terms and do not remedy that breach within 14 days
                of you notifying us of that breach; or
              </li>
              <li>
                <span>(b)</span>we breach these Terms and that breach cannot be remedied, and if
                you have paid fees for recurring Services upfront, you will be issued a pro-rata
                refund of any unused part of those fees based on the portion of the then-current
                Services period remaining.
              </li>
            </ol>
          </li>
          <li>
            <span>12.5</span>You may also terminate these Terms at any time by notifying us through
            your Account or to our email for notices (as set out in clause 13.8), and if you have
            purchased any recurring services, termination will take effect at the end of your
            current Services period.
          </li>
          <li>
            <span>12.6</span>Upon termination of these Terms, we will retain Your Data (including
            copies) as required by law or regulatory requirements.
          </li>
          <li>
            <span>12.7</span>Termination of these Terms will not affect any other rights or
            liabilities that we or you may have.
          </li>
          <li>
            <span>12.8</span>This clause 11 will survive the termination or expiry of these Terms.
          </li>
        </ol>
        <ol>
          <li><span>13.</span>General</li>
          <li>
            <span>13.1</span><strong>Assignment</strong>: You may not transfer or assign these
            Terms (including any benefits or obligations you have under these Terms) to any third
            party without our prior written consent. We may assign or transfer these Terms to a
            third party, or transfer any debt owed by you to us to a debt collector or other third
            party.
          </li>
          <li>
            <span>13.2</span><strong>Disputes</strong>: Neither we or you may commence court
            proceedings relating to any dispute, controversy or claim arising from, or in connection
            with, these Terms (including any question regarding its existence, validity or
            termination) (Dispute) unless we and you first meet (in good faith) to resolve the
            Dispute. Nothing in this clause will operate to prevent us or you from seeking urgent
            injunctive or equitable relief from a court of appropriate jurisdiction.
            <p>If the Dispute is not resolved at that initial meeting:</p>
            <ol>
              <li>
                <span>(a)</span>where you are resident or incorporated in Australia, refer the
                matter to mediation, administered by the Australian Disputes Centre in accordance
                with Australian Disputes Centre Guidelines for Commercial Mediation; or
              </li>
              <li>
                <span>(b)</span>where you are not resident or incorporated in Australia, refer the
                matter to arbitration administered by the Australian Centre for International
                Commercial Arbitration, with such arbitration to be conducted in Victoria, Victoria,
                before one arbitrator, in English and in accordance with the ACICA Arbitration
                Rules.
              </li>
            </ol>
          </li>
          <li>
            <span>13.3</span><strong>Events Outside Our Control</strong>: We will not be liable for
            any delay or failure to perform our obligations (including the Services), if such delay
            or failure is caused or contributed to by an event or circumstance beyond our reasonable
            control.
          </li>
          <li>
            <span>13.4</span><strong>Governing law</strong>: These Terms are governed by the laws
            of Victoria, and any matter relating to these Terms is to be determined exclusively by
            the courts in Victoria and any courts entitled to hear appeals from those courts.
          </li>
          <li>
            <span>13.5</span><strong>Illegal Requests</strong>: We reserve the right to refuse any
            request for or in relation to the Services that we deem inappropriate, unethical,
            unreasonable, illegal or otherwise non-compliant with these Terms.
          </li>
          <li></li>
          <li>
            <span>13.6</span><strong>Marketing</strong>: You agree that we may send you electronic
            communications about our products and services. You may opt-out at any time by using the
            unsubscribe function in our electronic communications.
          </li>
          <li>
            <span>13.7</span><strong>Nature of Legal Relationship</strong>: These Terms do not
            create, and should not be interpreted so as to create, a partnership, joint venture,
            employment or agency relationship between us and you.
          </li>
          <li>
            <span>13.8</span><strong>Notices</strong>: Any notice you send to us must be sent to support@rxpad.com.au. Any notice we send to you will be sent to the 
email address registered against your Account.
          </li>
          <li>
            <span>13.9</span><strong>Professional Services Disclaimer</strong>: The Services do not
            constitute, and are not a substitute for, financial, legal or risk management advice.
          </li>
        </ol>
        <ol>
          <li><span>14.</span>Definitions</li>
          <li>
            <span>14.1</span>In these Terms:
            <p>
              <strong
                >Australian Medical Association Guidelines on Medical Certifications 2011 (revised
                2016)</strong
              >
              means the guidelines published by the Australian Medical Association, as updated from
              time to time, which clarifies the roles and responsibilities of health practitioners.
            </p>
            <p>
              <strong>Account</strong> means an account accessible to the individual or entity who
              signed up to the Services linked to us as a service provider or third-party practice
              authorised by us, under which Authorised Users may be granted with access.
            </p>
            <p>
              <strong>Authorised User</strong> means a user that you have invited to use the
              Services through your Account.
            </p>
            <p>
              <strong>Consequential Loss</strong> includes any consequential loss, special or
              indirect loss, real or anticipated loss of profit, loss of benefit, loss of revenue,
              loss of business, loss of goodwill, loss of opportunity, loss of savings, loss of
              reputation, loss of use and/or loss or corruption of data, whether under statute,
              contract, equity, tort (including negligence), indemnity or otherwise. However, your
              obligation to pay us any amounts for access to or use of the Services (including the
              Services) will not constitute “Consequential Loss”.
            </p>
            <p>
              <strong>Health Practitioner National Law</strong> means the legislation that was
              enacted in each state and territory of Australia, being the
              <i>Health Practitioner Regulation National Law (Victoria) Act</i> 2009 in Victoria.
            </p>
            <p>
              <strong>Health Record Acts</strong> means the relevant state and territory legislation
              which establishes a framework to protect the privacy of individuals’ health
              information, being the Health Records Act 2001 in Victoria.
            </p>
            <p>
              <strong>Liability</strong> means any expense, cost, liability, loss, damage, claim,
              notice, entitlement, investigation, demand, proceeding or judgment (whether under
              statute, contract, equity, tort (including negligence), indemnity or otherwise),
              howsoever arising, whether direct or indirect and/or whether present, unascertained,
              future or contingent and whether involving a third party or us or you or otherwise.
            </p>
            <p>
              <strong>Medical Board of Australia Code of Conduct</strong> means the code of conduct
              established by the Australian Medical Association which establishes the professional
              standards required of doctors.
            </p>
            <p>
              <strong>Personal Information</strong> means any information or opinion about an
              identified individual, or an individual who is reasonably identifiable, whether the
              information or opinion is true or not, and whether the information or opinion is
              recorded in a tangible form or not.
            </p>
            <p><strong>Privacy Act</strong> means the <i>Privacy Act 1988</i> (Cth).</p>
            <p>
              <strong>Privacy Laws</strong> means the Privacy Act and any other applicable Laws
              relating to privacy.
            </p>
            <p>
              <strong>Professional Registration Details</strong> means AHPRA registration number,
              healthcare provider identifier individual number and prescriber number, and any other
              relevant licence details.
            </p>
            <p>
              <strong>Security Incident</strong> means the actual or likely occurrence of any of the
              following in respect of the Personal Information that you (or your Authorised Users)
              receive or have access to in connection with these Terms, or otherwise share on the
              Platform:
              <ol>
                <li>
                  <span>(a)</span>a breach by you (or your Authorised Users) of clause 8.8, 8.9 and 8.10;  
                </li>
                <li><span>(b)</span>an ‘eligible data breach’ (as that term is defined in the Privacy Act) caused or contributed by you (or your Authorised Users).  </li>
              </ol>
            </p>
            <p>
              <strong>Services</strong> means the services we provide to you, as detailed at the beginning of these Terms. 
            </p>
            <p>
              <strong>Your Data</strong> means the information, materials, logos, documents, qualifications and other intellectual property or data supplied by you and your Authorised Users when receiving the Services or stored by or generated by your use of the Services, including any Personal Information collected, used, disclosed, stored or otherwise handled in connection with the Services. Your Data does not include any data or information that is generated as a result of your usage of the Services that is a back-end or internal output or an output otherwise generally not available to users of the Services.     
            </p>
          </li>
        </ol>
      </section>
    </body>
  </html>`

export const rxpadPrescriberAgreement = {
  revisionDate: '24-August-2025',
  contentHTML: rxpadPrescriberAgreementContent,
}
